// Small DOM helpers for the history popup. Content is always set as text, never as HTML.

// CSS classes of the history popup (styles in game/src/styles/game.css). The wiener_history_* ones come from the
// vendor history popup, so the container and close button look and behave like it.
export const HISTORY_CSS = {
    popup: "wiener_history_popup",
    container: "wiener_history_container bur_history_container",
    closeButton: "wiener_history_btn_close",
    closeButtonIcon: "wiener_history_btn_span",
    empty: "bur_history_empty",
    round: "bur_history",
    title: "bur_history_title",
    section: "bur_history_section",
    subtitle: "bur_history_subtitle",
    spin: "bur_history_spin",
    slide: "bur_history_slide",
    spinWins: "bur_history_spin_wins",
    table: "bur_history_table",
    summaryTable: "bur_history_summary",
    winsTable: "bur_history_wins",
    jackpotsTable: "bur_history_jackpots",
    symbol: "bur_history_symbol",
    symbolName: "bur_history_symbol_name",
    carousel: "bur_history_carousel",
    carouselHeader: "bur_history_carousel_header",
    carouselNav: "bur_history_carousel_nav",
    carouselCounter: "bur_history_carousel_counter",
    carouselBody: "bur_history_carousel_body",
    stepper: "bur_history_stepper",
    board: "bur_history_board",
    token: "bur_history_token",
    tokenWin: "bur_history_token_win",
    tokenOut: "bur_history_token_out",
    tokenCross: "bur_history_token_cross",
    tokenFade: "bur_history_token_fade",
    stepperControls: "bur_history_stepper_controls",
    stepperButton: "bur_history_stepper_button",
    stepperDots: "bur_history_stepper_dots",
    stepperDot: "bur_history_stepper_dot",
    stepperDotActive: "bur_history_stepper_dot_active",
    activeRow: "bur_history_active_row",
    winsAnimating: "bur_history_wins_animating"
} as const;

// A table cell: text or an element
export type HistoryCell = string | HTMLElement;

export function createElement(
    tag: string,
    className: string,
    text?: string
): HTMLElement {
    const element = document.createElement(tag);
    element.classList.add(className);
    if (text !== undefined) {
        element.textContent = text;
    }
    return element;
}

export function createTable(
    header: string[] | null,
    rows: HistoryCell[][],
    className: string
): HTMLTableElement {
    const table = document.createElement("table");
    table.classList.add(HISTORY_CSS.table, className);

    if (header) {
        const headRow = table.createTHead().insertRow();
        header.forEach((cell) => {
            const th = document.createElement("th");
            th.textContent = cell;
            headRow.appendChild(th);
        });
    }

    const body = table.createTBody();
    rows.forEach((row) => {
        const tr = body.insertRow();
        row.forEach((cell) => {
            const td = tr.insertCell();
            if (typeof cell === "string") {
                td.textContent = cell;
            } else {
                td.appendChild(cell);
            }
        });
    });

    return table;
}

// An image with its name as tooltip, or just the name when there is no image
export function createImageCell(
    image: string | null,
    name: string
): HTMLElement {
    const cell = createElement("span", HISTORY_CSS.symbol);
    if (image) {
        const img = document.createElement("img");
        img.decoding = "async";
        img.src = image;
        img.alt = name;
        img.title = name;
        cell.appendChild(img);
    } else {
        cell.appendChild(createElement("span", HISTORY_CSS.symbolName, name));
    }
    return cell;
}

export function appendAll(parent: Node, ...children: Node[]): void {
    children.forEach((child) => parent.appendChild(child));
}
